import type { ChangeCatalogItem, ChangeFormField, ChangeTypePolicy } from '../../types/changes';
import { TYPE_LABELS, labelChangeType } from './changeLabels';

export type ConditionalChoice = { value: string; label: string };

export type ChangeFormConditionalCatalogs = {
  typeOptions: ConditionalChoice[];
  categories: ChangeCatalogItem[];
  requesterAreas: ChangeCatalogItem[];
};

export function buildChangeTypeConditionalChoices(
  policies: ChangeTypePolicy[],
): ConditionalChoice[] {
  const active = (policies || []).filter((item) => item.is_active);
  if (active.length > 0) {
    return active.map((item) => ({
      value: item.code,
      label: labelChangeType(item.code, item.name),
    }));
  }
  return Object.keys(TYPE_LABELS).map((value) => ({
    value,
    label: TYPE_LABELS[value] || value,
  }));
}

const SAP_CLASSIFICATION_CHOICES: ConditionalChoice[] = [
  { value: 'sap', label: 'SAP' },
  { value: 'nao_sap', label: 'Não SAP' },
];

const SAP_HAS_REQUEST_CHOICES: ConditionalChoice[] = [
  { value: 'true', label: 'Sim' },
  { value: 'false', label: 'Não' },
];

/** Opções do valor condicional (valor gravado = código/id; rótulo amigável na UI). */
export function conditionalChoicesForFormField(
  field: Pick<ChangeFormField, 'kind' | 'native_key' | 'field_type' | 'options'>,
  catalogs: ChangeFormConditionalCatalogs,
): ConditionalChoice[] {
  if (field.field_type !== 'list') {
    return [];
  }
  if (field.kind === 'native') {
    const key = field.native_key || '';
    if (key === 'change_type') {
      return catalogs.typeOptions;
    }
    if (key === 'category_id') {
      return catalogs.categories.map((item) => ({
        value: String(item.id),
        label: item.name,
      }));
    }
    if (key === 'requester_area_id') {
      return catalogs.requesterAreas.map((item) => ({
        value: String(item.id),
        label: item.name,
      }));
    }
    if (key === 'sap_classification') {
      return SAP_CLASSIFICATION_CHOICES;
    }
    if (key === 'sap_has_request') {
      return SAP_HAS_REQUEST_CHOICES;
    }
    return [];
  }
  return (field.options || []).map((option) => ({ value: option, label: option }));
}
